import { render, staticRenderFns } from "./Tasktemplate.vue?vue&type=template&id=73e860ac&"
import script from "./Tasktemplate.vue?vue&type=script&lang=js&"
export * from "./Tasktemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports